var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpaceBgBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1125 755.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:.3;stroke:#fff;}.cls-1,.cls-2{fill:none;stroke-miterlimit:10;stroke-width:5px;}.cls-3{opacity:.48;}.cls-4{fill:#d1e5e1;}.cls-5{opacity:.26;}.cls-6{opacity:.1;}.cls-2{opacity:.13;stroke:#000;}.cls-7{fill:#b4ccc7;}"), /*#__PURE__*/React.createElement("symbol", {
    id: "New_Symbol_2",
    viewBox: "0 0 18.95 18.95"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 9.47,
    cy: 9.47,
    r: 9.47
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.47,2c4.12,0,7.47,3.35,7.47,7.47s-3.35,7.47-7.47,7.47-7.47-3.35-7.47-7.47S5.35,2,9.47,2M9.47,0C4.24,0,0,4.24,0,9.47s4.24,9.47,9.47,9.47,9.47-4.24,9.47-9.47S14.71,0,9.47,0h0Z"
  })))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "563.01 43.26 116.55 43.26 34.66 0 .51 0 .51 234.97 563.01 234.97 563.01 43.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "563.01 59.69 106.55 59.69 24.66 16.44 .51 16.44 .51 755.98 563.01 755.98 563.01 59.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "561.99 43.26 1008.45 43.26 1090.34 0 1124.49 0 1124.49 234.97 561.99 234.97 561.99 43.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "551.99 59.69 1018.45 59.69 1100.34 16.44 1124.49 16.44 1124.49 755.98 551.99 755.98 551.99 59.69"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    y1: 346.95,
    x2: 1125,
    y2: 346.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 352.04,
    x2: 1125,
    y2: 352.04
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 562.52,
    y1: 181.48,
    x2: 562.52,
    y2: 755.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 557.44,
    y1: 181.48,
    x2: 557.44,
    y2: 755.98
  })), /*#__PURE__*/React.createElement("use", {
    width: 18.95,
    height: 18.95,
    transform: "translate(1084.76 131.45)",
    xlinkHref: "#New_Symbol_2"
  }), /*#__PURE__*/React.createElement("use", {
    width: 18.95,
    height: 18.95,
    transform: "translate(21.9 131.45)",
    xlinkHref: "#New_Symbol_2"
  }), /*#__PURE__*/React.createElement("use", {
    width: 18.95,
    height: 18.95,
    transform: "translate(1084.76 371.8)",
    xlinkHref: "#New_Symbol_2"
  }), /*#__PURE__*/React.createElement("use", {
    width: 18.95,
    height: 18.95,
    transform: "translate(21.9 371.8)",
    xlinkHref: "#New_Symbol_2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    y1: 173.87,
    x2: 1125,
    y2: 173.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 178.95,
    x2: 1125,
    y2: 178.95
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceBgBottom);
export default __webpack_public_path__ + "static/media/space-bg-bottom.cf86903e66f744621eeae7ef21dbcf4a.svg";
export { ForwardRef as ReactComponent };